module.exports = __webpack_public_path__ + "assets/bg-study-sets.990a8fea.svg";